import { cn } from "@/modern/utils";
import { SWIVU_STANDARD_ICONS } from "@/other/constants/IconKeys.jsx";
import { VIEW_TYPES } from "@/other/constants/OtherKeys.jsx";
import bgContrastHelper from "@/other/utils/bgUtils";

interface EntityFinderTaskIconProps {
  color: string;
  hasSubtitle?: boolean;
}

/** Mini task-event swatch — solid color tile with contrast icon (scheduler metaphor). */
export function EntityFinderTaskIcon({ color, hasSubtitle }: EntityFinderTaskIconProps) {
  const taskIconClass = SWIVU_STANDARD_ICONS[VIEW_TYPES.tasks];
  const iconColor = bgContrastHelper(color, "#ffffff", "#141414");

  return (
    <div
      className={cn(
        "relative flex size-8 shrink-0 items-center justify-center overflow-hidden rounded-lg shadow-sm",
        hasSubtitle && "mt-0.5"
      )}
      style={{ backgroundColor: color }}
    >
      <span
        className="pointer-events-none absolute inset-0 bg-gradient-to-b from-white/25 via-transparent to-black/12"
        aria-hidden
      />
      <i
        className={cn(taskIconClass, "relative text-sm")}
        style={{ color: iconColor }}
        aria-hidden
      />
    </div>
  );
}
